function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0001 14.7251C17.0916 14.7251 14.7253 17.0913 14.7253 19.9998C14.7253 22.9083 17.0916 25.2745 20.0001 25.2745C22.9086 25.2745 25.2748 22.9083 25.2748 19.9998C25.2748 17.0913 22.9086 14.7251 20.0001 14.7251Z",
  fill: "#53AE67"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0002 7.36279C13.0319 7.36279 7.36279 13.0319 7.36279 20.0002C7.36279 26.9684 13.0319 32.6375 20.0002 32.6375C26.9684 32.6375 32.6375 26.9684 32.6375 20.0002C32.6375 13.0319 26.9684 7.36279 20.0002 7.36279ZM20.0002 27.9122C15.6374 27.9122 12.0881 24.3629 12.0881 20.0002C12.0881 15.6374 15.6374 12.0881 20.0002 12.0881C24.3629 12.0881 27.9122 15.6374 27.9122 20.0002C27.9122 24.3629 24.3629 27.9122 20.0002 27.9122Z",
  fill: "#53AE67"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 0C8.94532 0 0 8.94532 0 20C0 31.0547 8.94532 40 20 40C31.0547 40 40 31.0547 40 20C40 8.94532 31.0547 0 20 0ZM30.8033 30.8033C27.9197 33.6868 24.0831 35.2747 20 35.2747C15.9169 35.2747 12.0803 33.6868 9.19675 30.8033C6.31323 27.9197 4.72528 24.0831 4.72528 20C4.72528 15.9169 6.31323 12.0803 9.19675 9.19675C12.0803 6.31323 15.917 4.72528 20 4.72528C24.083 4.72528 27.9197 6.31323 30.8033 9.19675C33.6868 12.0803 35.2747 15.9169 35.2747 20C35.2747 24.0831 33.6868 27.9197 30.8033 30.8033Z",
  fill: "#53AE67"
});

function SvgIcMissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMissions);
export default __webpack_public_path__ + "static/media/ic_missions.7532a5ab.svg";
export { ForwardRef as ReactComponent };